<template>
  <div
    :class="[
      'digital-shelf--cover',
      `digital-shelf--cover_align-${ align }`,
      {
        'digital-shelf--cover_without-cover-background': !withCoverBackground,
        'digital-shelf--cover_is-default-cover': isDefaultCover || isLoaded === false,
        'digital-shelf--cover_with-meta': withMeta,
        [`digital-shelf--cover_horizontal-align-${ horizontalAlign }`]: horizontalAlign === 'center',
        [`digital-shelf--cover_availability-${ availability }`]: availability
      }
    ]"
    :style="{
      width: width
    }"
  >
    <div class="digital-shelf--cover-bg">
      <div
        class="digital-shelf--cover-wrapper"
        :style="{
          backgroundImage: `url('${ blurredCover }'), url('/images/defaultCover.blur.jpg')`
        }"
      ></div>
      <div
        v-if="isDefaultCover || isLoaded === false"
        class="digital-shelf--cover-wrapper_cover"
      >
        <p class="digital-shelf--cover-wrapper_title">{{ title }}</p>
        <p class="digital-shelf--cover-wrapper_author">{{ author }}</p>
      </div>

      <div
        v-if="isDefaultCover !== true"
        :class="[
          'digital-shelf--cover-wrapper_image',
          { 'digital-shelf--cover-wrapper_loading': isLoaded === false }
        ]"
      >
        <img
          ref="image"
          draggable="false"
          :src="$easyscreenRequest.lmsConnector.wrapCover(cover)"
          crossOrigin="annonimus"
        >

        <div v-if="withMeta" class="digital-shelf--cover-meta">
          <div class="digital-shelf--cover-type">
            {{ type }}
          </div>

          <div class="digital-shelf--cover-title">
            {{ _cutText(title, maxTitleLength) }}
          </div>
          <div class="digital-shelf--cover-author">
            {{ author }}
            <span v-if="year">({{ year }})</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" src="./cover.less" />
<script>
  import cutText from "@/lib/utils/cut-text.js";
  import checkImageStatus from "@/lib/utils/check-image-status.js";
  import getDominantImageColor from "@/lib/utils/get-dominant-image-color.js";

  export default {
    name: "digital-shelf_cover",
    props: {
      withCoverBackground: {
        type: Boolean,
        default: true
      },
      align: {
        type: String,
        default: "center",
        validator: _align => ["top", "center", "bottom"].includes(_align)
      },
      /* The title of material for fallback cover with default image. */
      title: String,
      /* The author of material for fallback cover with default image. */
      author: String,
      /* Url of the cover, from material detail (wihtout the host) */
      cover: {
        type: String,
        default: "/images/defaultCover.jpg"
      },
      // Show meta information: year, author, title and availability
      withMeta: {
        type: Boolean,
        default: false
      },
      /* Cut the title from meta infromation */
      maxTitleLength: {
        type: Number,
        default: 35
      },
      /* The publication year of material. */
      year: String,
      /* The type of material (book, cd and etc). */
      type: String,
      /* The availability of the material. Default: "unknown". */
      availability: {
        type: String,
        default: "unknown",
        validator: (_availability) => [
          "unknown",
          "available",
          "not-available",
          "available-online",
          "available-at-another-branch"
        ].includes(_availability)
      },
      horizontalAlign: {
        type: String,
        default: "center",
        validator: _align => ["top", "center", "bottom"].includes(_align)
      },
      /* Custom width of cover */
      width: [Number, String]
    },
    computed: {
      isDefaultCover() {
        return this.loadingFailed || (this.cover || "").includes("defaultCover.jpg");
      },
      blurredCover() {
        if (this.isDefaultCover) {
          return "/images/defaultCover.blur.jpg";
        }

        return this.$easyscreenRequest.lmsConnector.wrapCover(this.cover + "/blur");
      }
    },
    data() {
      return {
        loadingFailed: null,
        dominantColor: null,
        isLoaded: false
      };
    },
    methods: {
      /**
       * Proxy for cutText. See the @/lib/utils/cut-text.js
       */
      _cutText: cutText,
      /**
       * Check the cover status and applies default and set the failing status if needed.
       */
      _checkImageStatus() {
        if (this.$refs.image) {
          let imageStatus = checkImageStatus(this.$refs.image);
          this.isLoaded = imageStatus === 1;

          if (imageStatus === 0) {
            this.$refs.image.onload = this._checkImageStatus;
            this.$refs.image.onerror = this._checkImageStatus;
          } else if (imageStatus === -1) {
            this.loadingFailed = true;
            this.$emit("failed");
          }
        }
      }
    },
    async mounted() {
      this._checkImageStatus();
      this.dominantColor = getDominantImageColor(this.$refs.image);
      this.dominantColor = await this.dominantColor;
    }
  };
</script>
